import React, { useState } from 'react'
import Add from 'components/ui/Add'
import useKidsHook from './Kids.use'
import KidsCard from './KidsCard'
import KidsModal from './KidsModal'

const Kids = () => {
  const [showModal, setShowModal] = useState(false)
  const { data, error, fetching, addKid, editKid, removeKid } = useKidsHook()

  if (fetching) {
    return <div>Loading...</div>
  }

  if (error) {
    // TODO: replace with a generic error component.
    return <div>Oops! Something went wrong. Please refresh and try again.</div>
  }

  return (
    <div className="flex flex-wrap pt-4 -mx-2">
      <Add
        onClick={() => setShowModal(true)}
        className="absolute top-0 right-0 mr-4 -mt-6"
      />

      {data.length &&
        data.map((kid, key) => (
          <KidsCard
            key={key}
            kid={kid}
            callbacks={{
              edit: (payload) => editKid(payload),
              remove: (id) => removeKid(id),
            }}
          />
        ))}

      {showModal && (
        <KidsModal
          show={showModal}
          setShow={setShowModal}
          callbacks={{ add: (payload) => addKid(payload) }}
        />
      )}
    </div>
  )
}

export default Kids
